import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ResponseObject } from 'src/app/models/response-object.model';
import { SearchTopProvider, TopProviderResponse } from 'src/app/models/tax.model';
import { TaxService } from 'src/app/services/tax.service';

@Component({
  selector: 'app-top-provider-list',
  templateUrl: './top-provider-list.component.html',
  styleUrls: ['./top-provider-list.component.scss']
})
export class TopProviderListComponent implements OnInit {
  @Output() close = new EventEmitter<any>();
  @Input() search: SearchTopProvider = null;
  providers: TopProviderResponse[] = [];
  provider: TopProviderResponse = null;
  loading: boolean = true;

  constructor(
    private taxService: TaxService,
    private toastService: ToastrService
  ) {

  }

  ngOnInit(): void {
    this.taxService.getTopProviders(
      this.search.company,
      this.search.month,
      this.search.year
    ).subscribe({
      next: (response: ResponseObject) => {
        this.loading = false;
        let [firstElement, ...otherElements] = response.data as TopProviderResponse[];
        this.provider = firstElement;
        this.providers = otherElements;
      },
      error: (error: HttpErrorResponse) => {
        this.loading = false;
        this.toastService.error("Error al obtener los proveedores");
      }
    })
  }

}
